
import store from '../../config/store'

export default {

  data: () => ({
    officer: store.modal.dataModel,
  }),

  methods: {
    onCloseModal () {
      store.modal.active = false
    }
  }
}
